import React from 'react';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';

import { useTranslation } from 'src/i18n';
import { Button } from 'src/component/ds/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle
} from 'src/component/ds/ui/empty';
import type { DeviceListScope } from 'src/service/api/deviceList';

function scopeKind (scope?: DeviceListScope) {
  if (scope?.controllerId) return 'controller';
  if (scope?.panelId === 'other') return 'unassigned';
  if (scope?.panelId) return 'panel';
  if (scope?.commLoopId === 'other') return 'unassignedConnection';
  if (scope?.commLoopId) return 'connection';
  if (scope?.groupId) return 'group';
  return 'facility';
}

interface EmptyScopeProps {
  /** Unset for the whole facility. */
  scope?: DeviceListScope;
  onViewAllDevices?: () => void;
  className?: string;
}

export default function EmptyScope ({ scope, onViewAllDevices, className }: EmptyScopeProps) {
  const { t } = useTranslation();

  return (
    <Empty className={className}>
      <EmptyMedia variant='icon'>
        <WidgetsOutlinedIcon className='ds-size-6' aria-hidden='true' />
      </EmptyMedia>
      <EmptyHeader>
        <EmptyTitle>{t('deviceList.emptyScope.title')}</EmptyTitle>
        <EmptyDescription>{t(`deviceList.emptyScope.description.${scopeKind(scope)}`)}</EmptyDescription>
      </EmptyHeader>
      {onViewAllDevices && (
        <EmptyContent>
          <Button className='ds-px-4' onClick={onViewAllDevices}>
            {t('deviceList.emptyScope.viewDevices')}
          </Button>
        </EmptyContent>
      )}
    </Empty>
  );
}
